import { render, staticRenderFns } from "./Bankkbankonly.vue?vue&type=template&id=273dd516&"
import script from "./Bankkbankonly.vue?vue&type=script&lang=js&"
export * from "./Bankkbankonly.vue?vue&type=script&lang=js&"
import style0 from "./Bankkbankonly.vue?vue&type=style&index=0&id=273dd516&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports